import React, {useContext} from "react"
import {injectIntl} from "react-intl";
import {AsmlDeviceOverviewContext} from "./context/AsmlDeviceOverviewContext";
import ValidationTabBody from "../../commonui/mheValidation/ValidationTabBody";
import MHEValidationContextProvider from "../../mhevalidation/context/MHEValidationContext";

const InductCameraDeviceValidation = ({intl}) => {

    const {viewModel, dispatch} = useContext(AsmlDeviceOverviewContext);
    const deviceList = viewModel && viewModel.inductCameraDeviceInformation ?
        Object.values(viewModel.inductCameraDeviceInformation) : [];

    const props = {
        dispatch,
        deviceList,
        intl
    }

    return (<MHEValidationContextProvider><ValidationTabBody {...props}/></MHEValidationContextProvider> );
}

export default injectIntl(InductCameraDeviceValidation)


// WEBPACK FOOTER //
// ./src/components/devicemanagement/asmldevice/InductCameraDeviceValidation.js